
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Versailles dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Versailles certifiée Google Partner, soutient les entreprises versaillaises pour accroître leur visibilité en ligne et attirer de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Versailles dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Versailles certifiée Google Partner, soutient les entreprises versaillaises pour accroître leur visibilité en ligne et attirer de nouveaux clients.",
        },
      ],
    };
  },
};
